import config from "../../config";

// Mirrors the auth pattern used across the other controllers.
function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.key) {
    return { Authorization: "Token  " + user.key };
  }
  return {};
}

/**
 * Resolve an emailed deep link into the patient the insurance modal needs.
 *
 * Deliberately its own tiny fetch rather than a reuse of the patient-details
 * controller: this one hits the session-scoped endpoint that refuses another
 * clinic's records, which is the entire point of the link being safe to email.
 *
 * NOTE: no `statusHandeling` here. That helper turns any 404 into a global
 * redirect to #/error404, which would replace this page's own "not available to
 * your account" message — the one thing a forwarded-link reader should see.
 */
export const getInsuranceLinkTarget = async (patientId, policyId) => {
  const headers = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const query =
    `?patient=${encodeURIComponent(patientId)}` +
    (policyId ? `&policy=${encodeURIComponent(policyId)}` : "");

  const res = await fetch(
    new Request(`${config.apiGateway.URL}/clinics/link/insurance-target/${query}`, {
      method: "GET",
      headers,
    }),
  );
  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    json = null;
  }
  return { json, status: res.status };
};
